
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import { headerMenuIcons } from "@/core/helpers/config";

export default defineComponent({
  name: "btn_tutoriales",
  components: {},
  setup() {
    const route = useRoute();
    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };
    return {
      hasActiveChildren,
      headerMenuIcons,
    };
  },
});
